import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";

export default function StudentDetailsPopUp({
  full_name,
  father_name,
  mother_name,
  date_of_birth,
  personal_contact,
  parent_contact,
  personal_email,
  dtu_email,
  original_city,
  original_country,
  gender,
  closeModal,
  handleAddStudentDetails,
}) {
  const [formData, setFormData] = useState({
    full_name: full_name || "",
    father_name: father_name || "",
    mother_name: mother_name || "",
    date_of_birth: date_of_birth || "",
    personal_contact: personal_contact || "",
    parent_contact: parent_contact || "",
    personal_email: personal_email || "",
    dtu_email: dtu_email || "",
    original_city: original_city || "",
    original_country: original_country || "",
    gender: gender || "",
  });

  const genders = ["Male", "Female", "Others"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePopupSubmit = async (e) => {
    e.preventDefault();
    const {
      full_name,
      father_name,
      mother_name,
      date_of_birth,
      personal_contact,
      parent_contact,
      personal_email,
      dtu_email,
      original_city,
      original_country,
      gender,
    } = formData;
    if (
      !full_name ||
      !personal_contact ||
      !personal_email ||
      !dtu_email ||
      !date_of_birth ||
      !gender
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // Basic email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personal_email)) {
      toast.error("Please enter a valid personal email address.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dtu_email)) {
      toast.error("Please enter a valid DTU email address.");
      return;
    }

    // Basic phone number validation (10 digits)
    if (!/^\d{10}$/.test(personal_contact)) {
      toast.error("Please enter a valid 10-digit personal contact number.");
      return;
    }

    if (parent_contact && !/^\d{10}$/.test(parent_contact)) {
      toast.error("Please enter a valid 10-digit parent contact number.");
      return;
    }

    // Validate date of birth if provided
    if (date_of_birth) {
      const dobDate = new Date(date_of_birth);
      const today = new Date();
      if (dobDate > today) {
        toast.error("Date of birth cannot be in the future.");
        return;
      }
    }

    if (handleAddStudentDetails) {
      handleAddStudentDetails(formData);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 overflow-y-auto p-4">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] h-auto max-h-[90vh] p-8 bg-gray-900 rounded-[20px] overflow-y-auto"
      >
        <form
          className="text-white flex flex-col space-y-6"
          onSubmit={handlePopupSubmit}
        >
          {/* Full Name */}
          <div className="relative z-0 w-full group">
            <label htmlFor="full_name" className="block text-sm">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="full_name"
              id="full_name"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.full_name}
              required
            />
          </div>

          {/* Father's Name */}
          <div className="relative z-0 w-full group">
            <label htmlFor="father_name" className="block text-sm">
              Father's Name
            </label>
            <input
              type="text"
              name="father_name"
              id="father_name"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.father_name}
            />
          </div>

          {/* Mother's Name */}
          <div className="relative z-0 w-full group">
            <label htmlFor="mother_name" className="block text-sm">
              Mother's Name
            </label>
            <input
              type="text"
              name="mother_name"
              id="mother_name"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.mother_name}
            />
          </div>

          {/* Date of Birth */}
          <div className="relative z-0 w-full group">
            <label htmlFor="date_of_birth" className="block text-sm">
              Date of Birth <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="date_of_birth"
              id="date_of_birth"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.date_of_birth}
              required
              max={new Date().toISOString().split("T")[0]}
            />
          </div>

          {/* Gender Dropdown */}
          <div className="relative z-0 w-full group">
            <label htmlFor="gender" className="block text-sm">
              Gender <span className="text-red-500">*</span>
            </label>
            <select
              name="gender"
              id="gender"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleSelectChange}
              required
              value={formData.gender}
            >
              <option value="">Select Gender</option>
              {genders.map((gender) => (
                <option key={gender} value={gender}>
                  {gender}
                </option>
              ))}
            </select>
          </div>

          {/* Personal Contact */}
          <div className="relative z-0 w-full group">
            <label htmlFor="personal_contact" className="block text-sm">
              Personal Contact <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="personal_contact"
              id="personal_contact"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.personal_contact}
              required
              pattern="[0-9]{10}"
              title="Please enter a 10-digit phone number"
            />
          </div>

          {/* Parent Contact */}
          <div className="relative z-0 w-full group">
            <label htmlFor="parent_contact" className="block text-sm">
              Parent Contact
            </label>
            <input
              type="tel"
              name="parent_contact"
              id="parent_contact"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.parent_contact}
              pattern="[0-9]{10}"
              title="Please enter a 10-digit phone number"
            />
          </div>

          {/* Personal Email */}
          <div className="relative z-0 w-full group">
            <label htmlFor="personal_email" className="block text-sm">
              Personal Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="personal_email"
              id="personal_email"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.personal_email}
              required
            />
          </div>

          {/* DTU Email */}
          <div className="relative z-0 w-full group">
            <label htmlFor="dtu_email" className="block text-sm">
              DTU Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="dtu_email"
              id="dtu_email"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.dtu_email}
              required
            />
          </div>

          {/* Original City */}
          <div className="relative z-0 w-full group">
            <label htmlFor="original_city" className="block text-sm">
              City
            </label>
            <input
              type="text"
              name="original_city"
              id="original_city"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.original_city}
            />
          </div>

          {/* Original Country */}
          <div className="relative z-0 w-full group">
            <label htmlFor="original_country" className="block text-sm">
              Country
            </label>
            <input
              type="text"
              name="original_country"
              id="original_country"
              className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={handleChange}
              value={formData.original_country}
            />
          </div>

          {/* Red Star Explanation */}
          <p className="text-sm text-gray-400">
            <span className="text-red-500">*</span> compulsory fields
          </p>

          {/* Buttons */}
          <div className="flex items-center justify-between mt-5 space-x-4">
            <button
              type="submit"
              className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Update Details
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
            >
              Cancel
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
}
